import { faqs } from "@/mocks/faqs";
import FaqAccordion from "@/components/feature/FaqAccordion";

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-100">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-3 w-3 rounded-full border border-primary-400" />
            FAQ
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于看料大瓜
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            第一次来？这几个问题能帮你快速了解我们做什么、内容从哪里来，以及如何核对信息。
          </p>
          <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
              <i className="ri-information-line mt-0.5 text-primary-600" />
              仍有疑问？欢迎写信到 contact@kanliao-dagua.example.com，我们会在两个工作日内回复。
            </p>
          </div>
        </div>
        <div className="lg:col-span-3">
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}